import { Link } from "react-router-dom";

const popularServices = [
  {
    title: "Man & Van Rubbish Removal Service",
    price: "from £99.99",
    badge: "SAMEDAY COLLECTIONS",
    badgeStyle: "bg-cl-green text-white",
    href: "/rubbish-clearance",
    image: "https://cleario.uk/wp-content/uploads/2026/04/edited_e7431d0492d4d3c1b81c1cbf2f06e868_d11e671b-removebg-preview.png",
    imageBg: "#6CC412",
  },
  {
    title: "Bin Collection",
    price: "from £64.99",
    badge: "NEXT-DAY EMPTYING",
    badgeStyle: "bg-amber-400 text-cl-dark",
    href: "/private-bin-collection",
    image: "https://cleario.uk/wp-content/uploads/services/bin-collection.png",
    imageBg: "#f0fce4",
  },
  {
    title: "Furniture Removal",
    price: "from £73.49",
    badge: "SAMEDAY COLLECTIONS",
    badgeStyle: "bg-cl-green text-white",
    href: "/furniture-removal",
    image: "https://cleario.uk/wp-content/uploads/services/furniture-removal.png",
    imageBg: "#e8edf7",
  },
  {
    title: "House Clearance",
    price: "from £71.74",
    badge: "POPULAR",
    badgeStyle: "bg-cl-lime text-cl-dark",
    href: "/house-clearance",
    image: "https://cleario.uk/wp-content/uploads/services/house-clearance.png",
    imageBg: "#6CC412",
  },
  {
    title: "Appliance Removal",
    price: "from £71.74",
    badge: "SAMEDAY COLLECTIONS",
    badgeStyle: "bg-cl-green text-white",
    href: "/appliance-removal",
    image: "https://cleario.uk/wp-content/uploads/services/appliance-removal.png",
    imageBg: "#e8edf7",
  },
  {
    title: "Sofa Removal",
    price: "from £73.49",
    badge: "SAMEDAY COLLECTIONS",
    badgeStyle: "bg-cl-green text-white",
    href: "/sofa-removal",
    image: "https://public.readdy.ai/ai/img_res/edited_f547d9d29aecbbb892b0086ac3b98fcc_23f71a2d.jpg",
    imageBg: "#e8edf7",
  },
];

export default function ContactServices() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-cl-lime rounded-full px-4 py-1.5 mb-4 thick-border cartoon-shadow-sm">
            <i className="ri-service-line text-cl-dark text-xs"></i>
            <span className="text-cl-dark text-xs font-black uppercase tracking-widest">Cleario Services</span>
          </div>
          <h2 className="font-black text-cl-dark mb-3" style={{ fontSize: "clamp(1.8rem, 3.5vw, 2.8rem)" }}>
            Our most popular services
          </h2>
          <p className="text-cl-dark/55 text-base font-semibold max-w-lg mx-auto">
            We&apos;re on stand-by to help with any queries above, if you&apos;re ready to order here&apos;s our most used services.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {popularServices.map((service) => (
            <Link
              key={service.title}
              to={service.href}
              className="group flex items-center gap-4 bg-white rounded-2xl p-4 thick-border cartoon-shadow-sm hover:cartoon-shadow transition-all cursor-pointer"
            >
              <div
                className="w-20 h-20 flex items-center justify-center rounded-xl overflow-hidden flex-shrink-0"
                style={{ background: service.imageBg }}
              >
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="flex-1 min-w-0">
                <span
                  className={`inline-block text-[10px] font-black px-2.5 py-0.5 rounded-full mb-1.5 ${service.badgeStyle}`}
                  style={{ border: "1.5px solid rgba(0,0,0,0.10)" }}
                >
                  {service.badge}
                </span>
                <p className="text-cl-dark font-black text-sm leading-tight mb-0.5">{service.title}</p>
                <p className="text-cl-green font-black text-sm">{service.price}</p>
              </div>
              <span className="w-8 h-8 flex items-center justify-center flex-shrink-0 rounded-xl bg-cl-lime thick-border group-hover:bg-cl-green transition-colors">
                <i className="ri-arrow-right-line text-cl-dark group-hover:text-white text-sm transition-colors"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}